import optimizelySDK, { Client, setLogLevel } from '@optimizely/optimizely-sdk';

import { EventProps, TrackerConfig, TrackerEvent, UserEvent } from '../../types/services';

import { trackEvents } from '../../config/events';
import { uuid } from '../../helpers/string';
import StorageService from '../storage-service';

class OptimilizeTracker extends TrackerEvent {
  optimizelyClientInstance: Client | null = null;

  valid = (key: keyof TrackerConfig) => {
    return trackEvents.optimizely.enabled && trackEvents.optimizely[key];
  };

  init = () => {
    if (this.valid('enabled')) {
      try {
        this.optimizelyClientInstance = optimizelySDK.createInstance({
          sdkKey: process.env.REACT_APP_OPTIMIZE_SDK_KEY,
        });
        setLogLevel('ERROR');
        const localUserId = StorageService.get<string>('AstroOptimizelyUserId');
        if (!localUserId) {
          StorageService.set('AstroOptimizelyUserId', uuid());
        }
        super.init();
      } catch {}
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  trackUser = (user: UserEvent) => {
    //
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  trackEvent = (eventName: string, props: EventProps) => {
    //
  };
}

export default new OptimilizeTracker();
